module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DARKNESS RISING")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0013-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter3d#hc5",
      "id": "ch5"
    }
  }, [_vm._v("2. ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0013-02-1"
    }
  }, [_c('span', [_vm._v("“Into the lions’ den,” Dani said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-2"
    }
  }, [_c('span', [_vm._v("“Danielle and the lions,” Tommy said. “That has a ring to it. Hopefully we’ll get the same kind of help he had.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-3"
    }
  }, [_c('span', [_vm._v("“Hopefully we won’t need it,” Dani said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-4"
    }
  }, [_c('span', [_vm._v("“We’re here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-5"
    }
  }, [_c('span', [_vm._v("Tommy put the Jaguar in neutral, handed his keys to the parking valet, a boy who didn’t look old enough to drive, walked around the front of the car, and opened the door for Dani. Couples waiting to enter had gathered on the patio outside the art museum, men in tuxedos and cashmere overcoats, women accessorized in pearls and gold and diamond chandelier earrings.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-6"
    }
  }, [_c('span', [_vm._v("The last time Dani Harris, a forensic psychiatrist, and Tommy Gunderson, her “assistant,” had visited St. Adrian’s Academy for Boys, it had been to question a boy they’d suspected of murdering a girl named Julie Leonard at a place called Bull’s Rock Hill. Dani’s employer, Ralston-Foley Behavioral Consulting, had been hired to consult with the district attorney’s office. Although the DA had officially closed the case, as far as Dani and Tommy were concerned, it wasn’t over. And though Dani was technically on leave of absence to deal with any post-traumatic stress disorders she might be experiencing, she knew there was no time to waste.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-7"
    }
  }, [_c('span', [_vm._v("“Ready when you are,” Tommy said. In his pocket he had a device he’d"), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v(" purchased on the Internet, an electronic bug in the form of a coil of wire with what looked like a small black transformer on one end and a USB jack on the other. It could be plugged into a free USB port in the back of any computer, where its presence would go unnoticed, hidden in plain sight in the nest of wires and cords most people had connecting their peripheral devices. Once programmed and in place, it would use the Internet to transfer all the host-computer’s hard drive and keystroke data to a second monitoring computer, in this case, Tommy’s. They’d come to plant the bug or die trying, though dying wasn’t part of the plan, exactly.")])])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-01-1"
    }
  }, [_c('span', [_vm._v("“Onward,” Dani replied, offering Tommy her elbow.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "p_14_-2"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Ilf_9781595549457_INT_0014_002.gif",
      "src": "images/Ilf_9781595549457_INT_0014_002.gif"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0014-03-3"
    }
  }, [_c('span', [_vm._v("The art museum was a brightly lit modern building with straight, clean lines and white surfaces on an ancient campus where the dormitories, halls, administration building, and student commons favored stone or red brick covered with ivy, slate roofs, garrets, balconies, leaded windows, bell towers, sloping dormers, marble cornices, and chimneys capped in wrought iron.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-4"
    }
  }, [_c('span', [_vm._v("The occasion was an exhibition marking the first time the major works of Dutch renaissance painter Hieronymus Bosch had been shown in America. The show included his mysterious triptych "), _c('i', [_vm._v("Garden of Earthly Delights")]), _vm._v(", on loan from the Prado in Madrid but owned by St. Adrian’s alumnus Udo Bauer, a German multibillionaire whose family owned Linz Pharmazeutika. Dani’s boss had received an invitation but had a prior commitment and couldn’t attend. Dani had said she’d be happy to go in her stead, though “happy” wasn’t the right word, because she didn’t know how to be happy and scared at the same time.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-5"
    }
  }, [_c('span', [_vm._v("Inside, Tommy steered Dani to the coatroom off the entry hall.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-6"
    }
  }, [_c('span', [_vm._v("“Quite the turnout,” Dani said. “A Who’s Who of East Salem.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("The reception was in the atrium. Boys in black pants, white shirts, and")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v(" black bow ties circulated bearing silver trays of canapés or glasses of wine. Dani accepted a tomato and basil bruschetta as Tommy surveyed the room.")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('span', [_vm._v("“Keep an eye out for anything that isn’t human,” he said. “And make allowances for bad plastic surgery.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-1"
    }
  }, [_c('span', [_vm._v("They passed two women in conversation, both of whom looked like their faces had been shrink-wrapped in cellophane. A student string ensemble in the corner provided chamber music. They played well, Dani thought, but mechanically and without much feeling. There was, she noted, a kind of flattened affect to many of the boys in attendance, a palpable stiffness. They were all polite but unsmiling, slightly robotic. Her evaluation of the St. Adrian’s student they’d suspected, Amos Kasden, had been that he’d suffered from a dissociative identity disorder. His mind had become disconnected from his body and nothing seemed real to him, emotions reduced to ideas, and confusing ones at that. Zero empathy. Somewhere in the computer belonging to Dr. Adolf Ghieri, the school psychologist, there had to be a file on Amos. What it would tell them, they could only guess, but that was the computer they were targeting.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-2"
    }
  }, [_c('span', [_vm._v("“You’re rocking the room, by the way,” Tommy said. “You’re what women who have plastic surgery wish they looked like.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-3"
    }
  }, [_c('span', [_vm._v("Dani was wearing a sleeveless black Carmen Marc Valvo cocktail dress she’d picked up at a sample sale, with black and tan ribbing at the bodice above a taffeta skirt, accessorized with silver earrings, a silver evening bag, and a pair of Prada knockoff shoes she’d picked up at T.J. Maxx for $25. Tommy wore the black Armani tuxedo he’d purchased the first time he’d accepted the ESPY award as NFL Defensive Player of the Year, tailored to allow extra room for his broad shoulders and less for his tapered waist.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-4"
    }
  }, [_c('span', [_vm._v("“Thanks,” Dani said. “I assume you mean that as a compliment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-5"
    }
  }, [_c('span', [_vm._v("He touched her arm and gestured toward a group of men standing near a statue of a figure Tommy guessed was St. Adrian, the school’s namesake.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-6"
    }
  }, [_c('span', [_vm._v("“There’s Wharton,” he said.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("Dr. John Adams Wharton, the headmaster, was shaking hands and")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" greeting guests. He wore a black tux, his position of authority marked only by the boutonniere in the school colors of purple and red pinned to his lapel. His long, thinning white hair was brushed straight back.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-1"
    }
  }, [_c('span', [_vm._v("“Where’s Ghieri?” Dani said. The school psychologist had seemed menacing and defensive when they’d questioned Amos Kasden. Something about him exuded evil. Dani couldn’t put her finger on it, but Tommy had told her to trust her feelings, comparing it to the way people instinctively fear snakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-2"
    }
  }, [_c('span', [_vm._v("Then they saw him, balding and stout, standing between two men they didn’t recognize. One was in his seventies, with unkempt frizzy white hair, a white moustache, and round wire-rimmed eyeglasses. The other man was tall, fair-haired, and too tan for November; in his forties, with a long neck and a narrow head that reminded Tommy of a ferret. His expression was pinched and annoyed, as if he’d just caught a whiff of something foul.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-3"
    }
  }, [_c('span', [_vm._v("“I bet the tall one is Bauer,” Dani said. “He looks very German. And very rich.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-4"
    }
  }, [_c('span', [_vm._v("Tommy surveyed the room and noticed that all the exits were guarded by young men in black shirts with walkie-talkies and earpieces.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-5"
    }
  }, [_c('span', [_vm._v("“I know these paintings are valuable, but am I the only one who thinks there’s more security than they need?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-6"
    }
  }, [_c('span', [_vm._v("“Should we wait for a better time?” Dani asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-7"
    }
  }, [_c('span', [_vm._v("“No,” Tommy said. “As long as they’re concentrating on the paintings and not on Ghieri’s office, this could work in our favor. Plus, when are we going to get another invitation? Let’s chat ’em up and see if they recognize us. I’ll take Ghieri. See if you can get a rise out of Wharton.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-8"
    }
  }, [_c('span', [_vm._v("“By doing what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-9"
    }
  }, [_c('span', [_vm._v("“I don’t know. Flirt with him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-10"
    }
  }, [_c('span', [_vm._v("“Not in my skill set,” Dani said. “My sister says I must have skipped class the day they covered that in Girl School.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-01-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“Don’t overthink it. Just pretend you care. Laugh at his jokes. If a guy thinks a pretty woman is interested in him, he’ll change the litter in her")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v(" cat’s litter box,” Tommy said. “Which reminds me—I changed the litter in Arlo’s litter box.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-1"
    }
  }, [_c('span', [_vm._v("“Thank you,” Dani said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-2"
    }
  }, [_c('span', [_vm._v("“Don’t underestimate yourself. Text me if you need me.” Tommy patted the phone in his breast pocket.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-3"
    }
  }, [_c('span', [_vm._v("Dani furrowed her brow. “Be careful,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-4"
    }
  }, [_c('span', [_vm._v("“You know me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-5"
    }
  }, [_c('span', [_vm._v("“That’s why I said ‘Be careful.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-6"
    }
  }, [_c('span', [_vm._v("She straightened his bow tie and brushed a bit of lint from his shoulder, then moved left, accepting a glass of chardonnay from one of the waiters. Then she set it down, found her phone, and entered SOS in a text message for Tommy’s mobile number, ready to send just in case.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-7"
    }
  }, [_c('span', [_vm._v("She paused to chat with two women from her book club. They were reading "), _c('i', [_vm._v("War and Peace")]), _vm._v(", having recently finished "), _c('i', [_vm._v("Moby Dick")]), _vm._v(". “We really need to pick thinner books,” one said. Dani nodded and kept moving.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-8"
    }
  }, [_c('span', [_vm._v("She had no problem engaging strangers at dinner parties, looking judges or attorneys in the eye, teaching classes at John Jay College of Criminal Justice, or speaking at conferences, but idle chitchat was a challenge for her. Dani knew men found submissive women attractive because it made them feel powerful, but how did one fake “submissive”?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-9"
    }
  }, [_c('span', [_vm._v("Dr. Wharton, the German, the man with the moustache, and a fourth man were standing by a framed Albrecht Dürer sketch of a rhinoceros. The older man, the one with the moustache, seemed to be explaining something to the others as Dani approached.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-10"
    }
  }, [_c('span', [_vm._v("“Dr. Wharton,” she said. “I’m Dani Harris. Irene Scotto asked me to give you her regrets. She had a conference in Washington, so she sent me here to represent the district attorney’s office.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-11"
    }
  }, [_c('span', [_vm._v("“Yes,” Wharton said, giving no sign that he remembered meeting Dani or cared whom she might be representing. “I’m pleased you could attend.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-01-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Dani remembered Tommy’s advice, but there was nothing funny in the")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v(" words "), _c('i', [_vm._v("I’m pleased you could attend")]), _vm._v(". She thought of how idiotic it would be to laugh, and she must have made a face, because Wharton looked at her as if she were utterly demented. So much for flirting.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-1"
    }
  }, [_c('span', [_vm._v("“If you’ll excuse me,” he said with a polite bow and a puzzled expression, moving on to greet another guest.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-2"
    }
  }, [_c('span', [_vm._v("“Miss Harris,” the fair-haired man said, without a hint of a German accent. “Are you here by yourself?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-3"
    }
  }, [_c('span', [_vm._v("“I came with someone from my office,” she said, holding up her glass. “He’s probably looking for me—”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-4"
    }
  }, [_c('span', [_vm._v("“Udo Bauer,” the man said, extending his hand. She took it, half expecting him to click his heels together. “Let me introduce my friends. Dr. Julian Villanegre. Dr. Peter Guryakin. Dr. Villanegre is here to oversee the installation. Dr. Guryakin works for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-5"
    }
  }, [_c('span', [_vm._v("Dani shook hands with the white-haired Villanegre and then with Guryakin, whose name rang a bell.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-6"
    }
  }, [_c('span', [_vm._v("“And what do you do, Miss Harris?” Dr. Villanegre said, surprising her with his British accent.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-7"
    }
  }, [_c('span', [_vm._v("“I work at Northern Westchester Hospital.” She had visitation privileges there but rarely used them.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-8"
    }
  }, [_c('span', [_vm._v("“You’re a nurse?” Bauer said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-9"
    }
  }, [_c('span', [_vm._v("“A doctor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-10"
    }
  }, [_c('span', [_vm._v("“My apologies,” Bauer said. “My personal physician is a fat old man with liver spots on his liver spots. I can’t picture doctors any other way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-11"
    }
  }, [_c('span', [_vm._v("“I also consult with the DA’s office as a forensic psychiatrist,” she added, looking for a reaction. Usually when she told people her job title, they asked her what it meant, and she’d explain that she evaluated suspects and witnesses for competency and testified in court as to the emotional or mental state of the accused.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("“I was just explaining to my friends what an astonishing anatomist Dürer was,” Villanegre said, pointing at the drawing mounted on the wall. “He drew his rhinoceros based entirely on a description a friend gave him")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v(" of an animal being exhibited in Lisbon. The friend said the animal wore armor, so the artist took the liberty of adding rivets. Other than that, I think he got it right.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-1"
    }
  }, [_c('span', [_vm._v("In her peripheral vision, Dani saw Bauer peeking down the bodice of her dress.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-2"
    }
  }, [_c('span', [_vm._v("“You’re an art historian?” she said to Villanegre. “Professional or amateur?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-3"
    }
  }, [_c('span', [_vm._v("“I curate for the Ashmolean in Oxford, but Mr. Bauer asked me to supervise the shipping of the works. Have you seen "), _c('i', [_vm._v("The Garden of Earthly Delights")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-4"
    }
  }, [_c('span', [_vm._v("“Not yet,” Dani said. She turned to the shorter man. “Dr. Guryakin, you work for Herr Bauer—may I ask in what capacity?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-5"
    }
  }, [_c('span', [_vm._v("“Yes,” he said, nodding politely. Dani watched as he touched his nose and folded his arms across his chest. When he spoke, his lower lip pulled to the left. She’d been trained to recognize signs that a suspect was lying, and Guryakin had just hit the trifecta. “I work in marketing,” he said. His accent was Russian.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-6"
    }
  }, [_c('span', [_vm._v("“You’re a charming young woman, and it’s been a pleasure meeting you,” Villanegre said, “but I’m afraid I have to go prepare for my little talk. If you’ll excuse me . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-01-7"
    }
  }, [_c('span', [_vm._v("Dani smiled and nodded. Then Villanegre stopped and looked her in the eyes as if he recognized something. His face a foot from hers, he studied her, as if unaware that she was looking back, and then he seemed to nod to himself. Dani had no idea what it meant, but she felt as if she’d been caught at something.")])]), _vm._v(" "), _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "p_19_-8"
    }
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Ilf_9781595549457_INT_0019_002.gif",
      "src": "images/Ilf_9781595549457_INT_0019_002.gif"
    }
  })])])]), _c('p', {
    staticClass: "tx100",
    attrs: {
      "id": "p0019-03-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Tommy had trouble moving through the crowd. He’d played in the NFL for eight years, was a six-time Pro Bowler when he walked away from the game after killing an opposing player on the field—a clean hit, it was")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" ruled, but a tragic accident. He didn’t care what the league called it; he only knew it wasn’t going to happen again. His picture still ended up in the tabloids from time to time. He’d learned that men from the highest social circles and men who raked leaves for a living and preferred Budweiser over Chateau Lafite Rothschild often had in common a love of football. This usually served Tommy well, but made it hard to walk through a party without shaking a hundred hands.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-1"
    }
  }, [_c('span', [_vm._v("He kept moving, chatting people up. The fact that a teenage girl had been murdered by a St. Adrian’s student less than a month before did little to dampen the party mood on campus tonight. He made small talk but kept Ghieri in his sights, working to get closer. But every time Tommy moved, Ghieri moved too.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-2"
    }
  }, [_c('span', [_vm._v("He gave up trying to catch the man alone when the doors to the main gallery swung open and the crowd filtered in. He found Dani by the statue of St. Adrian.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-3"
    }
  }, [_c('span', [_vm._v("“Any luck?” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-4"
    }
  }, [_c('span', [_vm._v("“Not much. I learned you can’t teach here unless you’re a graduate,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-5"
    }
  }, [_c('span', [_vm._v("“Hence the term ‘Old Boy Network.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-6"
    }
  }, [_c('span', [_vm._v("“You?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-7"
    }
  }, [_c('span', [_vm._v("“I was right about Bauer. The man with the Albert Einstein hair and the moustache is an art historian. The other guy works for Bauer. Dr. Peter Guryakin. When I asked him what he did, he lied and said he was in marketing. I Googled his name.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-8"
    }
  }, [_c('span', [_vm._v("“And?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-9"
    }
  }, [_c('span', [_vm._v("“Nothing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-10"
    }
  }, [_c('span', [_vm._v("“Who gets zero hits on Google?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-11"
    }
  }, [_c('span', [_vm._v("“That’s what I thought,” Dani said. “Unless somebody scrubbed the databases. Shall we go in and have a look at the painting?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0020-01-12"
    }
  }, [_c('span', [_vm._v("“If I get a chance to slip out—” Tommy began, then stopped, momentarily distracted by the statue. “That’s odd.”")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“What is?”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-1"
    }
  }, [_c('span', [_vm._v("“This is St. Adrian,” he said. “The guy they named the school after, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-2"
    }
  }, [_c('span', [_vm._v("“And?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-3"
    }
  }, [_c('span', [_vm._v("“He was the abbot of St. Augustine’s Abbey in Canterbury around 700 AD.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-4"
    }
  }, [_c('span', [_vm._v("“So what’s odd?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-5"
    }
  }, [_c('span', [_vm._v("“He’s not wearing a cross,” Tommy said. “You’d think he’d have one. So why doesn’t he?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-6"
    }
  }, [_c('span', [_vm._v("“Good question,” Dani said. She stepped closer and examined the figure’s hands.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-7"
    }
  }, [_c('span', [_vm._v("“What?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-8"
    }
  }, [_c('span', [_vm._v("“Look at the marks on his fingers, here and here.” She pointed for Tommy’s sake but tried not to draw attention. “The statue looks like it was weathered everywhere except there. As though he "), _c('i', [_vm._v("was ")]), _vm._v("holding a cross, until someone removed it. Why? Someone stole it because it was valuable?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0021-01-9"
    }
  }, [_c('span', [_vm._v("“Maybe it was just something the administration didn’t want the student body exposed to,” Tommy said. “They might get ideas.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6061275e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 84
// module chunks = 0